import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { BlogManager } from "@/pages/admin/BlogManager";
import { PodcastManager } from "@/pages/admin/PodcastManager";
import { EventsManager } from "@/pages/admin/EventsManager";
import { ClientsManager } from "@/pages/admin/ClientsManager";

export default function AdminDashboard() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] p-6" data-testid="admin-dashboard-page">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h1 className="font-['Cutive'] text-2xl font-bold">Bring Me Cash — Backoffice</h1>
          <Button variant="outline" onClick={handleLogout} data-testid="admin-logout-button">
            Sair
          </Button>
        </div>
        <Tabs defaultValue="clients" className="w-full">
          <TabsList data-testid="admin-tabs">
            <TabsTrigger value="clients" data-testid="admin-tab-clients">Clientes</TabsTrigger>
            <TabsTrigger value="blog" data-testid="admin-tab-blog">Blog</TabsTrigger>
            <TabsTrigger value="podcast" data-testid="admin-tab-podcast">Podcast</TabsTrigger>
            <TabsTrigger value="events" data-testid="admin-tab-events">Eventos</TabsTrigger>
          </TabsList>
          <TabsContent value="clients"><ClientsManager /></TabsContent>
          <TabsContent value="blog"><BlogManager /></TabsContent>
          <TabsContent value="podcast"><PodcastManager /></TabsContent>
          <TabsContent value="events"><EventsManager /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
